<div ngbDropdown display="dynamic" placement="bottom-end" class="d-inline-block">
    <button class="btn btn-outline btn-outline-secondary" id="languageDropdownToggle" ngbDropdownToggle>
        {{ currentLanguage.code | uppercase }}
    </button>
    <div ngbDropdownMenu aria-labelledby="languageDropdownToggle">
        @for (language of languages; track language.code) {
        <button ngbDropdownItem [class.active]="language.code === currentLanguage.code"
            (click)="selectLanguage(language.code)">
            {{ language.label }}
        </button>
        }
    </div>
</div>
